'use client';

import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from '@/lib/intl';

/**
 * Invalidates price-sensitive React Query caches when the shopper changes locale.
 */
export function useLocalePricingInvalidation(): void {
  const queryClient = useQueryClient();
  const { countryConfig } = useIntl();
  const currency = countryConfig.currency.code;
  const country = countryConfig.countryCode;
  const prevRef = useRef({ currency, country });

  useEffect(() => {
    const prev = prevRef.current;
    if (prev.currency === currency && prev.country === country) {
      return;
    }
    prevRef.current = { currency, country };

    void queryClient.invalidateQueries({ queryKey: ['product-page'] });
    void queryClient.invalidateQueries({ queryKey: ['collection-page'] });
    void queryClient.invalidateQueries({ queryKey: ['pack-page'] });
    void queryClient.invalidateQueries({ queryKey: ['product-pricing'] });
    void queryClient.invalidateQueries({ queryKey: ['volume-tiers'] });
    void queryClient.invalidateQueries({ queryKey: ['pack-price'] });
    void queryClient.invalidateQueries({ queryKey: ['recommendations'] });
  }, [currency, country, queryClient]);
}
